import { render, staticRenderFns } from "./PeriodicExportDeleteDialog.vue?vue&type=template&id=2a9a78c4"
import script from "./PeriodicExportDeleteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodicExportDeleteDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports